import GA4Events from "//pettena.jp/cdn/shop/t/92/assets/ga4.events.js?v=83321235349968374011788437024";

;(function($) {
	$(document).ready(function() {
		$("[ga4-controls]").on("click", function() {
			const eventName = _.toLower($(this).attr("ga4-controls"));
			if (typeof GA4Events[eventName] !== "undefined") {
				const defaultAttrs = {
					"content_type": $(this).attr("ga4-controls"),
					"section_id": $(this).attr("ga4-section-id"),
					"section_name": $(this).attr("ga4-section-name"),
				};
				// console.log(defaultAttrs);
				GA4Events[eventName].apply(this, [this, defaultAttrs]);
			} else {
				console.log(`GA4 event named {${eventName}} is not defined`);
			}
		});
	});
})(jQuery);